import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../atoms/Button/Button';
import Modal from '../Modal/Modal';
import Carousel from '../Carousel/Carousel';
import defaultImg from '../../../assets/images/default-image.jpg';

import './UnitImages.scss';

const UnitImages = ({
  images,
  isLoading,
}) => {
  const [modalState, setModalState] = useState({
    imageModal: false,
  });
  const previewImage = images.length > 0 ? images[0] : defaultImg;
  const hasPrimaryImage = images.length > 0;

  return (
    <div className="unitImages">
      {/* eslint-disable-next-line no-nested-ternary */}
      <div className="quote__image" data-testid={isLoading ? 'unit-image-loading' : hasPrimaryImage ? 'unit-image' : 'no-images'}>
        {isLoading ? (
          <div className="unitImages__loading">Loading image...</div>
        ) : (
          <img
            src={previewImage}
            alt="Unit"
            className="img unitImages__image"
          />
        )}
      </div>
      {!isLoading && hasPrimaryImage && (
      <>
        <Button
          plain
          title="Enlarge"
          className="enlargeButton"
          onClick={() => setModalState({ imageModal: true })}
        />

        {modalState.imageModal && (
        <Modal modalState={modalState} modalName="imageModal" setModalState={setModalState}>
          <Carousel imageKeys={images} />
        </Modal>
        )}
      </>
      )}
    </div>
  );
};

UnitImages.propTypes = {
  images: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool,
};

UnitImages.defaultProps = {
  isLoading: false,
};

export default UnitImages;
